import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import "react-chat-widget/lib/styles.css";

import PropTypes from "prop-types";

const useStyles = makeStyles(() => ({
  "@keyframes waterColor": {
    from: { backgroundColor: "#dbf450bd" },
    to: { backgroundColor: "#f4f7f9" },
  },
  unreadMessage: {
    backgroundColor: "#f4f7f9",
    borderRadius: "10px",
    padding: "15px",
    maxWidth: "215px",
    textAlign: "left",
    boxSizing: "inherit",
    display: "block",
    lineHeight: "1.43",
    animation: "$waterColor 8s",
    animationTimingFunction: "ease",
  },
  "@keyframes blinker": {
    from: { opacity: 0.3 },
    to: { opacity: 1 },
  },
  unreadNoMargin: {
    margin: "0px",
    fontSize: "0.875rem",
    animation: "$blinker 8s",
    animationTimingFunction: "ease",
  },
}));

export const ChatNewMessage = ({ message, time }) => {
  const classes = useStyles();

  return (
    <div className="rcw-message">
      <img src="/no_profile.png" className="rcw-avatar" alt="avatar" />
      <div className="rcw-response">
        <div className={`${classes.unreadMessage}`}>
          <p className={classes.unreadNoMargin}>{message}</p>
        </div>
        <span className="rcw-timestamp">{time}</span>
      </div>
    </div>
  );
};
ChatNewMessage.propTypes = {
  message: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
};
